if (('ontouchstart' in window) ||  (window.DocumentTouch && document instanceof DocumentTouch) || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints) {
  document.documentElement.classList.add('support-touch');
};

function variantSelection() {
  let featured_product = document.getElementById('shopify-section-template--17447051133079__featured_product_V88xd4');
  let options = document.querySelectorAll('.product-option-clone');

  if(!options.length || !featured_product) return;

  let set_selling_plan = featured_product.querySelector('.customSelectionSellgroup');
  let triggerAddtoCart = featured_product.querySelector('.product-form__submit');
  let btns = document.querySelectorAll('.addtocart--placeholder');
  btns.forEach(btn => {
    btn.addEventListener('click', function(){
      triggerAddtoCart.click();
    });
  });

  options.forEach(option => {
    option.addEventListener('click', function(){
      let container = this.closest('.ProductModuleContainer');
      let allTabs = container.querySelectorAll('.product--detail');

      let selling_id = this.dataset.sellingPlan;

      if(selling_id) {
        set_selling_plan.value = selling_id;
      } else {
        set_selling_plan.value = '';
      }
      
      allTabs.forEach(tab => tab.classList.remove('visible'));
      options.forEach(o => o.classList.remove('product-option--selected'));

      this.classList.add('product-option--selected');
      container.querySelector('#' + this.dataset.tabId)?.classList.add('visible');
      
      featured_product?.querySelector(`label[for="${this.dataset.variantId}"]`)?.click();
    });
  });

   document.getElementById('onePersonOption')?.click();
}

document.addEventListener('DOMContentLoaded', variantSelection);

document.querySelector('.subscription_product').addEventListener('click', (event) => {
  const onePersonOption = document.querySelector('#onePersonOption');
  const twoPeopleOption = document.querySelector('#twoPeopleOption');
  
  // Check if neither has the 'product-option--selected' class
  const isOnePersonSelected = onePersonOption.classList.contains('product-option--selected');
  const isTwoPeopleSelected = twoPeopleOption.classList.contains('product-option--selected');

  if (!isOnePersonSelected && !isTwoPeopleSelected) {
    // Simulate a click on #onePersonOption
    onePersonOption.click();
  }
});

